module.exports = __webpack_public_path__ + "media/images/icons/icons_small/64_tworings-6afbd2f104da6b267c493edb9699b596.png";